const FilterEmailConfigTabs = Object.freeze({
  Members: "member",
  Filter: "filter",
  EmailList: "emailList",
  Settings: "settings",
});
export default FilterEmailConfigTabs;
